<template>
  <div class="card mb-4">
    <TableInfoBar
      :total="totalItems"
      v-model:pageSize="pageSize"
      :page-sizes="pageSizes"
      v-model:query="q"
      :searchPlaceholder="'이름/GTIN 검색'"
      @search="onSearch"
    />

    <div class="card-body px-4 pt-0 pb-2">
      <BaseDataTable
        :loading="loading"
        :items="productList"
        :columns="columns"
        :total="totalItems"
        v-model:page="page"
        v-model:pageSize="pageSize"
        :page-sizes="pageSizes"
        :colgroup="colgroup"
        :rowKey="rowKey"
        empty-message="등록된 제품이 없습니다."
        @row-click="onRowClick"
      >
        <template #row="{ item, index }">
          <td class="text-center text-sm">{{ totalItems - rowStartIndex - index }}</td>
          <td class="text-center text-sm">{{ item.name }}</td>
          <td class="text-center text-sm"><CustomBadge level="very-high" size="sm" :label="item.gtin" /><!-- <soft-badge color="info" variant="gradient" size="sm">{{ item.gtin }}</soft-badge> --></td>
          <td class="text-center text-sm"><CustomBadge level="very-high" size="sm" :label="item.urn" /><!-- <soft-badge color="info" variant="gradient" size="sm">{{ item.urn }}</soft-badge> --></td>
          <td class="text-center text-sm"><CustomBadge level="low" size="sm" :label="item.currentBizStep" /><!-- <soft-badge color="secondary" variant="gradient" size="sm">{{ item.currentBizStep }}</soft-badge> --></td>
          <td class="text-center text-sm">{{ formatDate(item.eventTime) }}</td>
        </template>
      </BaseDataTable>
    </div>
  </div>
</template>

<script>
import CustomBadge from '@/components/CustomBadge.vue';
import BaseDataTable from '@/components/BaseDataTable.vue';
import SoftBadge from "@/components/SoftBadge.vue";
import TableInfoBar from '@/components/pagination/TableInfoBar.vue';
import api from '@/api/api';

export default {
  name: "product-trace-table",
  components: { CustomBadge, BaseDataTable, TableInfoBar, SoftBadge },
  data() {
    return {
      loading: true,
      productList: [],
      categoryList: [],

      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20, 50],
      totalItems: 0,
      sort: 'createdAt,desc',

      columns: [
        { label: 'No.' },
        { label: '제품명' },
        { label: 'GTIN' },
        { label: 'URN' },
        { label: '현재 상태' },
        { label: '생성일시' },
      ],
      colgroup: [
        'width:10%',
        'width:18%',
        'width:15%',
        'width:27%',
        'width:10%',
        'width:20%',
      ],
      q: "",
    };
  },
  computed: {
    mfId() {
      return this.$store.getters['UserStore/getMfId'];
    },
    rowStartIndex() {
      return (this.page - 1) * this.pageSize;
    },
    categoryMap() {
      return (this.categoryList || []).reduce((acc, cur) => {
        acc[cur.categoryCode] = cur.categoryName;
        return acc;
      }, {});
    }
  },
  watch: {
    page() { this.fetchData(); },
    pageSize() { this.page = 1; this.fetchData(); },
  },
  mounted() {
    this.fetchData();
    this.initData();
  },
  methods: {
    rowKey(item, idx) { return item.id ?? idx; },
    formatDate(dt) { return dt ? new Date(dt).toLocaleString() : ''; },

    async fetchData() {
      this.loading = true;
      try {
        const [res] = await Promise.all([
          api.get('/productTrace/page', {
            params: { mfId: this.mfId, page: this.page, size: this.pageSize, sort: this.sort, query: this.q }
          }),
          // UX: 로딩 최소 표시 시간
          new Promise(r => setTimeout(r, 600)),
        ]);

        const r = res.data?.result || {};
        this.productList = r.items || [];
        this.totalItems = Number(r.total || 0);

        if (r.page && r.page !== this.page) this.page = r.page;
        if (r.size && r.size !== this.pageSize) this.pageSize = r.size;

        const pageCount = Math.max(1, Math.ceil(this.totalItems / this.pageSize));
        if (this.page > pageCount) this.page = pageCount;
      } catch (error) {
        console.error("제품 추적 목록 불러오기 실패:", error);
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      this.page = 1;
      this.fetchData();
    },
    async initData() {
      try {
        const { data } = await api.get('/productTrace/initData', { params: { mfId: this.mfId } });
        const result = data?.result || {};
        this.categoryList = result.categoryList || [];
      } catch (error) {
        console.error("초기 데이터 불러오기 실패:", error);
      }
    },

    onRowClick(item) {
      this.$router.push({ path: '/productTrace/detail', query: { id: item.id, urn: item.urn } });
    },
  }
};
</script>
